<template>
  <section class="resource-links">
    <div class="container">
      <div class="item" v-for="item in items" :key="item.title">
        <div class="icon">
          <el-icon :size="42">
            <component :is="item.icon" />
          </el-icon>
        </div>
        <div class="title">{{ item.title }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  Reading,
  Collection,
  User,
  Link
} from '@element-plus/icons-vue'
export default {
  name: 'ResourceLinks',
  data() {
    return {
      items: [
        {
          title: '数字图书馆',
          icon: Reading
        },
        {
          title: '实验室知识库',
          icon: Collection
        },
        {
          title: '山东化学化工学会',
          icon: User
        },
        {
          title: '学术出版物',
          icon: Link
        }
      ]
    }
  }
}
</script>
<style scoped src="@/assets/styles/resourcelinks.css"></style>
